import { Alert, AlertDescription } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, Sparkles, AlertCircle } from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface RenewalIndicatorProps {
  isRenewal: boolean;
  renewalCount: number;
  lastTransactionDate: string | null;
  isLoading: boolean;
}

export function RenewalIndicator({
  isRenewal,
  renewalCount,
  lastTransactionDate,
  isLoading,
}: RenewalIndicatorProps) {
  if (isLoading) {
    return (
      <Alert className="border-blue-200 bg-blue-50">
        <AlertCircle className="h-4 w-4 text-blue-600" />
        <AlertDescription className="text-blue-800">
          Verificando histórico do cliente...
        </AlertDescription>
      </Alert>
    );
  }

  if (isRenewal) {
    return (
      <Alert className="border-green-200 bg-green-50">
        <CheckCircle2 className="h-4 w-4 text-green-600" />
        <AlertDescription className="text-green-800 flex items-center gap-2">
          <span className="font-semibold">Renovação detectada!</span>
          <Badge variant="outline" className="bg-white">
            {renewalCount}ª transação
          </Badge>
          {lastTransactionDate && (
            <span className="text-sm">
              Última compra: {format(new Date(lastTransactionDate), 'dd/MM/yyyy', { locale: ptBR })}
            </span>
          )}
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Alert className="border-purple-200 bg-purple-50">
      <Sparkles className="h-4 w-4 text-purple-600" />
      <AlertDescription className="text-purple-800">
        <span className="font-semibold">Nova aquisição!</span> Este será o primeiro pagamento deste plano para este cliente.
      </AlertDescription>
    </Alert>
  );
}
